import { render, staticRenderFns } from "./LPG.vue?vue&type=template&id=3ffa7be4"
import script from "./LPG.vue?vue&type=script&lang=js"
export * from "./LPG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports